/**
 * Associate Party
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const AssociatePartyState = {}

export const AssociatePartyActions = {
  async unassociateParty ({ commit }, requestData) {
    return axiosRequest.
      delete(`/records/${requestData.recordId}/parties/${requestData.partyId}`).
      catch(handleError)
  },
}

export const AssociatePartyMutations = {}

export const AssociatePartyGetters = {}
